/* eslint-disable max-len */
import {
  useCallback, useEffect, useState,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import devicesAction from '@state/device/actions';
import devicesApi from '@api/devicesApi';

function useCreateGateway() {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const dataInit = useSelector(({ device: a }) => a.createNewGateway);
  const idToEdit = useSelector(({ device: a }) => a.gatewayIdToEdit);

  const [dataForm, setDataForm] = useState(dataInit);
  const [dataFirmwares, setDataFirmwares] = useState([]);

  const [loadingSave, setLoadingSave] = useState(false);

  const currentUserRol = useSelector(({ user }) => user.role);
  const [businessData, setBusinessData] = useState([]);

  const abortC = new AbortController();
  const { signal } = abortC;

  const skip = 0;
  const limit = 1000;
  const defaultData = {
    name: '',
    mac: '',
    state: 'normal',
    fw_assigned_id: '',
    latitude: 0,
    longitude: 0,
    hwInt: '',
    baud: '',
    ival: '',
    device_api_key_id: [],
  };

  const onFinish = useCallback((values) => { // submit: create or edit gateway

    if (!idToEdit) { //  create gateway

      const data = dataInit;

      data.baud = Number(data.baud);
      data.ival = Number(data.ival);

      console.log(dataInit);

      setLoadingSave(true);
      devicesApi.createGateway({ signal, body: data })
        .then((response) => {

          const { id } = response;

          devicesApi.enableCSGateway({ signal, body: { can_check_cs: true }, id }).then(() => {

            message.success(t('views.create_gateway.form.create_success'));
            setDataForm(defaultData);
            dispatch(devicesAction.setCreateEditGateway(defaultData));
            dispatch(devicesAction.setGatewayIdEdit(null));
            setLoadingSave(false);
            history.push('/dispositivos/gateway');

          });

        })
        .catch((resError) => {

          setLoadingSave(false);
          console.log(resError);
          // eslint-disable-next-line
          message.error(resError?.data?.detail || t('views.create_gateway.form.create_error'));

        });

    } else { // Edit gateway

      const data = dataInit;

      data.baud = Number(data.baud);
      data.ival = Number(data.ival);

      setLoadingSave(true);

      devicesApi.editGateway({ signal, body: data, id: idToEdit })
        .then((response) => {

          message.info(t('views.create_gateway.form.edit_success'));
          setDataForm(defaultData);
          dispatch(devicesAction.setCreateEditGateway(defaultData));
          dispatch(devicesAction.setGatewayIdEdit(null));
          setLoadingSave(false);
          history.push('/dispositivos/gateway');

        })
        .catch((resError) => {

          setLoadingSave(false);
          console.log(resError);
          // eslint-disable-next-line
          message.error(resError?.data?.detail || t('views.create_gateway.form.edit_error'));

        });

    }

    // eslint-disable-next-line
  }, [dispatch, signal]);

  const onFinishFailed = (errorInfo) => { // data imcomplete

    // eslint-disable-next-line
    console.log(errorInfo.errorFields[0].errors[0]);
    message.error(errorInfo.errorFields[0].errors[0]);

  };

  const formOnValuesChange = useCallback( // handle data
    (value) => {

      const key = Object.keys(value);
      const data = Object.values(value);

      setDataForm({ ...dataForm, [key[0]]: data[0] });
      dispatch(devicesAction.setCreateEditGateway({ ...dataForm, [key[0]]: data[0] }));

    },
    // eslint-disable-next-line
    [dataForm, dispatch]
  );

  const onDataFw = (value) => { // data imcomplete

    // eslint-disable-next-line
    getFirmwares(value)

};

  const getFirmwares = useCallback( // get the firmware data
    (businessTypeIds) => {

      let businessTypeIdsQuery = '';

      if (businessTypeIds !== '' || businessTypeIds !== undefined) {

            businessTypeIdsQuery += `business_type_id=${businessTypeIds}`;

}

      devicesApi.getAllFirmwaresByBusiness(signal, skip, limit, businessTypeIdsQuery)
        .then((response) => {

          setDataFirmwares(response);

        })
        .catch((error) => {

          // eslint-disable-next-line
          console.log('error: ', error);

        });

    },
    // eslint-disable-next-line
    [dataFirmwares, dispatch]
  );

  const cancelCreateEditGateway = useCallback(
    () => {

      history.replace('/dispositivos/gateway');

    },
    // eslint-disable-next-line
    [],

  );

  const readBusinessType = useCallback(async () => {

    await devicesApi.getAllBusinessType({ signal, skip, limit })
      .then(async (business) => {

          const newBusiness = await Promise.all(business.map(async (obj) => {

            const item = {
              value: obj.id,
              label: obj.name,
              devices: obj.total_general,
              clients: obj.total_general_clients,
              type: obj.type,
            };
            return item;

}));

          setBusinessData(newBusiness);

      }).catch((resError) => {

          if (signal.aborted) return;
          const { fem } = resError;
          console.log('fem ', fem);

      });

  });

  const handleGatewayHome = () => {

    cancelCreateEditGateway();

  };

  useEffect(() => { // mount component

    getFirmwares(dataInit?.busines_id);
    readBusinessType();

    if (!idToEdit && location.pathname === '/dispositivos/gateway/editar-gateway') {

        // If trying to edit without idToEdit, redirect to tipo-negocio
        dispatch(devicesAction.setGatewayIdEdit(null));
      dispatch(devicesAction.setCreateEditGateway(defaultData));
        history.push('/dispositivos/gateway');

    } else if (!idToEdit && currentUserRol !== 'Superadmin' && currentUserRol !== 'Admin') {

      dispatch(devicesAction.setGatewayIdEdit(null));
      dispatch(devicesAction.setCreateEditGateway(defaultData));

      // If trying to create without idToEdit and not Superadmin or Admin, redirect to tipo-negocio
          history.push('/dispositivos/gateway');

}
    return function cleanUp() {

      if (idToEdit) {

        dispatch(devicesAction.setGatewayIdEdit(null));
        dispatch(devicesAction.setCreateEditGateway(defaultData));

}

};
    // eslint-disable-next-line
  }, []);

  return {
    onFinish,
    onFinishFailed,
    formOnValuesChange,
    dataForm,
    dataFirmwares,
    idToEdit,
    cancelCreateEditGateway,
    handleGatewayHome,
    loadingSave,
    businessData,
    onDataFw,
  };

}

export default useCreateGateway;
